<template>
  <fragment>
    <div class="tagTwo">
      <div class="box">current location：{{ title }}</div>
    </div>
  </fragment>
</template>

<script>
// import { authInformation } from '@/api/authorizationManagement';
export default {
  name: 'authorizationManagement',
  data: function () {
    return {
      data: {},
    };
  },
  computed: {
    title() {
      console.log(this.$route);
      return this.$route.meta.urlTitle;
    },
  },
  created() {},
  methods: {},
};
</script>

<style scoped lang="less">
.tagTwo {
  padding: 0 25px;
  box-sizing: border-box;
  .box {
    height: 35px;
    line-height: 35px;
    font-size: 14px;
    // font-weight: bold;
    color: #5d7198;
    position: relative;
  }
  // .box::after {
  //   position: absolute;
  //   left: 0;
  //   bottom: -2px;
  //   content: '';
  //   width: 100%;
  //   height: 1px;
  //   background-color: #4b5b7e;
  //   border-radius: 3px;
  // }
}
</style>
